import React, { useState } from 'react';

export default function Hero() {
  const [p1, setP1] = useState(false);
  const [p2, setP2] = useState(false);
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
      paddingTop: '80px',
      background: 'var(--hero-bg)',
    }}>
      {/* Subtle green glow top-right */}
      <div style={{
        position: 'absolute',
        top: '-10%',
        right: '-5%',
        width: '600px',
        height: '600px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(160,206,78,0.12) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div style={{
        position: 'relative',
        zIndex: 1,
        textAlign: 'center',
        maxWidth: '960px',
        padding: '0 32px',
        animation: 'fadeUp 0.9s ease 0.1s both',
      }}>
        {/* Badge */}
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          fontFamily: 'var(--font-body)',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '0.2em',
          textTransform: 'uppercase',
          color: 'var(--accent)',
          marginBottom: '36px',
          padding: '8px 20px',
          border: '1px solid rgba(160,206,78,0.3)',
          borderRadius: '100px',
        }}>
          <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: 'var(--accent)', display: 'inline-block' }} />
          Influencer Marketing Agency
        </div>

        {/* Headline */}
        <h1 style={{
          fontFamily: 'var(--font-display)',
          fontSize: 'clamp(52px, 9vw, 108px)',
          fontWeight: 900,
          lineHeight: 0.95,
          color: 'var(--white)',
          letterSpacing: '-0.03em',
          marginBottom: '36px',
          textTransform: 'uppercase',
        }}>
          Where Brands<br />
          <span style={{ color: 'var(--accent)', fontStyle: 'italic', fontWeight: 800 }}>Ascend</span>
        </h1>

        {/* Subtext */}
        <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: 'clamp(15px, 1.6vw, 18px)',
          fontWeight: 400,
          color: 'rgba(255,255,255,0.55)',
          maxWidth: '540px',
          margin: '0 auto 52px',
          lineHeight: 1.75,
        }}>
          Niles Ascend connects visionary brands with cultural creators to build campaigns that move audiences and drive measurable results.
        </p>

        {/* CTAs */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', flexWrap: 'wrap' }}>
          <button
            onClick={() => scrollTo('brands')}
            style={{
              fontFamily: 'var(--font-body)',
              fontSize: '13px',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              padding: '16px 40px',
              background: p1 ? 'var(--accent-dark)' : 'var(--accent)',
              color: '#0a0a0a',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
            onMouseEnter={() => setP1(true)}
            onMouseLeave={() => setP1(false)}
          >
            For Brands
          </button>
          <button
            onClick={() => scrollTo('creators')}
            style={{
              fontFamily: 'var(--font-body)',
              fontSize: '13px',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              padding: '16px 40px',
              background: 'transparent',
              color: 'var(--white)',
              border: '1.5px solid rgba(255,255,255,0.3)',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'border-color 0.2s',
              borderColor: p2 ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.3)',
            }}
            onMouseEnter={() => setP2(true)}
            onMouseLeave={() => setP2(false)}
          >
            For Creators
          </button>
        </div>

        {/* Stats row */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '48px',
          marginTop: '72px',
          flexWrap: 'wrap',
        }}>
          {[['500+', 'Vetted Creators'], ['100+', 'Brand Partners'], ['24h', 'Response Time']].map(([num, label]) => (
            <div key={label} style={{ textAlign: 'center' }}>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: '32px', fontWeight: 800, color: 'var(--accent)', lineHeight: 1 }}>{num}</div>
              <div style={{ fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 500, color: 'rgba(255,255,255,0.4)', letterSpacing: '0.12em', textTransform: 'uppercase', marginTop: '6px' }}>{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
